export function scrollToTop(top = 0) {
  const container = document.documentElement;
  if (!container) {
    return;
  }
  container.scrollTo({
    top: top,
    behavior: "instant",
  });
}
